"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftSidebar = void 0;
const ui_1 = require("@app/component/ui");
const modal_sidebar_button_1 = require("@app/component/ui/modal/modal-sidebar/modal-sidebar-button");
const util_1 = require("@app/util");
const maybe_1 = require("@app/util/functional/maybe");
const is_admin_1 = require("@app/util/hooks/is-admin");
const react_1 = __importDefault(require("react"));
const shift_context_1 = require("../shift-context");
const use_available_shift_sections_1 = require("../use-available-shift-sections");
const isSectionChecked = (arr, sec) => arr.includes(sec);
const SidebarItem = ({ section }) => {
    const { toggleSection, toggledSections, disabledEditation, transferType, transferStatus, } = (0, shift_context_1.useShift)();
    const { name, id } = section;
    return (react_1.default.createElement("div", { style: { display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' } }, section.id === 'transfer' &&
        (transferStatus === 'accepted' ||
            transferStatus === 'pending' ||
            transferType === 'dsProTransfer') ? (react_1.default.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'row',
            gap: '0.375rem',
        } },
        react_1.default.createElement(ui_1.Icon, { color: 'black', ico: 'check', size: 'small' }),
        react_1.default.createElement(ui_1.Text, { type: 'body-large' }, name))) : (react_1.default.createElement(ui_1.Checkbox, { testid: `${section.id}-shift-section`, disabled: section.isBlocked ||
            ((0, util_1.isDefined)(disabledEditation) && !section?.isCustomAttribute), onDisabledClick: () => {
            if ((0, util_1.isDefined)(disabledEditation)) {
                return;
            }
            if ((0, util_1.isDefined)(section.onBlockedContent)) {
                section.onBlockedContent();
            }
        }, checked: isSectionChecked(toggledSections, id), onChange: (v) => {
            toggleSection(id, v);
        } },
        react_1.default.createElement(ui_1.Text, { type: 'body-large' }, name)))));
};
const ShiftSidebar = () => {
    const { selectedTab, setSelectedTab, formType, initialData } = (0, shift_context_1.useShift)();
    const isAdmin = (0, is_admin_1.useIsAdmin)();
    const shiftSections = (0, use_available_shift_sections_1.useAvailableShiftSections)();
    const shiftSettings = shiftSections.filter((section) => section.isCustomAttribute === false || (0, util_1.isUndefined)(section.isCustomAttribute));
    const shiftAttributes = shiftSections.filter((section) => section.isCustomAttribute === true);
    const IS_REQUIREMENTS_BASED_TYPE = formType === 'template';
    const sidebarScrollRef = react_1.default.useRef(null);
    const [isScrollable, setIsScrollable] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        const currentSidebarScrollRef = sidebarScrollRef.current;
        if (!(0, util_1.isValue)(currentSidebarScrollRef)) {
            return;
        }
        const eventListener = (ev) => {
            const TOLERANCE = 5;
            const _isScrollable = new maybe_1.Maybe(ev.target)
                .map((sidebarScroll) => sidebarScroll.scrollHeight > sidebarScroll.clientHeight &&
                sidebarScroll.scrollTop + TOLERANCE <
                    sidebarScroll.scrollHeight - sidebarScroll.clientHeight)
                .get(() => false);
            setIsScrollable((prev) => {
                if (prev === _isScrollable)
                    return prev;
                return _isScrollable;
            });
        };
        currentSidebarScrollRef.addEventListener('scroll', eventListener);
        const _isScrollable = new maybe_1.Maybe(sidebarScrollRef.current)
            .map((sidebarScroll) => sidebarScroll.scrollHeight > sidebarScroll.clientHeight &&
            sidebarScroll.scrollTop <
                sidebarScroll.scrollHeight - sidebarScroll.clientHeight)
            .get(() => false);
        setIsScrollable(_isScrollable);
        return () => currentSidebarScrollRef.removeEventListener('scroll', eventListener);
    }, []);
    return (react_1.default.createElement("div", { style: {
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            padding: '0.375rem',
            paddingRight: 0,
        } },
        react_1.default.createElement("div", { style: {
                flex: 0,
                height: 'max-content',
                marginBottom: '0.5rem',
                paddingRight: '0.375rem',
            } },
            react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { ico: 'template', selected: selectedTab === 'overview', onClick: () => setSelectedTab('overview'), style: { alignItems: 'center', gap: '0.5rem', flexShrink: 0 } }, (0, util_1.t)('DASHBOARD'))),
        react_1.default.createElement("div", { ref: sidebarScrollRef, style: {
                flexBasis: '100%',
                flex: 1,
                height: '100%',
                width: '100%',
                overflowY: 'auto',
                padding: '0 0.5rem',
                boxShadow: isScrollable
                    ? 'inset 0 -10px 10px -10px rgb(0 0 0 / 10%)'
                    : undefined,
            } }, selectedTab === 'overview' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui_1.Text, { type: 'body-large', weight: 'bold', style: {
                        marginBottom: '0.75rem',
                    } }, (0, util_1.t)('SHIFT_SETTINGS')),
                react_1.default.createElement(SidebarItem, { section: shiftSettings[0] })),
            shiftSettings
                .slice(1)
                .filter((s) => (0, util_1.isUndefined)(s.visible) || s.visible)
                .map((section) => (react_1.default.createElement(SidebarItem, { key: section.id, section: section }))),
            !IS_REQUIREMENTS_BASED_TYPE && shiftAttributes.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(ui_1.Text, { type: 'body-large', weight: 'bold', style: {
                            marginBottom: '0.75rem',
                        } }, (0, util_1.t)('SHIFT_ATTRIBUTES_NAV_NAME')),
                    react_1.default.createElement(SidebarItem, { section: shiftAttributes[0] })),
                shiftAttributes.slice(1).map((section) => (react_1.default.createElement(SidebarItem, { key: section.id, section: section })))))))),
        react_1.default.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                flex: 0,
                height: 'max-content',
                paddingRight: '0.375rem',
            } },
            isAdmin && (react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { ico: 'template', selected: selectedTab === 'dev-view', onClick: () => setSelectedTab('dev-view'), style: { alignItems: 'center', gap: '0.5rem', flexShrink: 0 } }, "Dev tools")),
            react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { ico: 'template', selected: selectedTab === 'statistics', onClick: () => setSelectedTab('statistics'), style: { alignItems: 'center', gap: '0.5rem', flexShrink: 0 } }, (0, util_1.t)('SHIFT_STATS_TITLE')),
            initialData?.type === 'template' ||
                initialData?.type === 'shiftTemplate' ||
                initialData?.type === 'cycle' ? null : (react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { ico: 'template', selected: selectedTab === 'history', onClick: () => setSelectedTab('history'), style: { alignItems: 'center', gap: '0.5rem', flexShrink: 0 } }, (0, util_1.t)('HISTORY'))))));
};
exports.ShiftSidebar = ShiftSidebar;
